import { inject, Service } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Service()
export class StateService 
{
  public data: any;
  
  public router: Router = inject(Router);
  public dialogRef: MatDialog = inject(MatDialog);

  constructor() 
  {
    this.init();
  }
  
  init()
  {
    this.data = new Object();
    this.data.userToken = null;
    this.data.refreshToken = null;
    this.data.userName = null;
    this.data.userTokenExpiration = 0;
  }
  
  persist()
  {
    sessionStorage.setItem("disneyadgate-session-data", JSON.stringify(this.data));
  }
  
  restore()
  {
    let sd = sessionStorage.getItem("disneyadgate-session-data");

    if (typeof sd != 'undefined' && sd != null ) {
      this.data = JSON.parse(sd);
    }
  }

  getUserName(): string
  {
    return this.data.userName;
  }
  
  getUserFirstName(): string
  {
    const names = this.data.userName.split(' ');
    return names[0];
  }
  
  getUserEmail(): string
  {
    return this.data.email;
  }

  navigate(path: string)
  {
    if(window.location.pathname == path) return;

    this.persist();
    this.router.navigate([path]);
  }

  getUserInitials(): string
  {
    const words = this.getUserName().trim().split(/\s+/);

    if (words.length === 0 || words[0] === '') return '';

    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }

    const firstInitial = words[0].charAt(0);
    const lastInitial = words[words.length - 1].charAt(0);

    return (firstInitial + lastInitial).toUpperCase();
  }

  saveFilter<T extends object>(key: string, filter: T): void
  {
    try {
      const filterJson = JSON.stringify(filter);
      localStorage.setItem(key, filterJson);
    } catch (error) {
      console.error(`Failed to save filter to localStorage with key '${key}':`, error);
    }
  }

  loadFilter<T extends object>(key: string, constructor: new () => T): T | null
  {
    try {
      const filterJson = localStorage.getItem(key);
      if (filterJson) {
        const filterData = JSON.parse(filterJson);
        const filter = new constructor();
        Object.assign(filter, filterData);
        return filter;
      }
    } catch (error) {
      console.error(`Failed to load filter from localStorage with key '${key}':`, error);
    }
    return null;
  }

  clearFilter(key: string): void
  {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Failed to clear filter from localStorage with key '${key}':`, error);
    }
  }
}
